/**
 * Scoring (module pur, teste). C'est le serveur qui fait foi : le client ne
 * l'utilise que pour afficher un score previsionnel pendant la phase GUESSING.
 *
 * Toutes les fonctions prennent des millisecondes et retournent des entiers.
 *
 * CHOIX DESIGN: le bareme est identique en mode classique et en mode flou. Le
 * mode flou rend mecaniquement les gros scores devineur plus rares : trouver en
 * moins de 3 secondes une image encore tres floue releve du pari. C'est assume
 * et non compense : ajouter un bonus de mode rendrait les scores de deux
 * parties incomparables, et transformerait un choix d'ambiance en choix
 * d'optimisation. Le mode change l'experience, pas la valeur des points.
 *
 * La duree de la phase est un PARAMETRE et non une constante : elle est reglable
 * par l'hote (settings.guessTime). Les deux courbes sont donc definies par leurs
 * bornes : plateau puis decroissance jusqu'a GUESSER_MIN_SCORE a `guessTimeMs`
 * pour le devineur, croissance de DRAWER_MIN_SCORE a DRAWER_MAX_SCORE sur la
 * meme duree pour le dessinateur. Le bareme est donc identique quelle que soit
 * la duree choisie, seule la pente change.
 */
import { DEFAULT_GUESS_TIME_MS, DRAWER_MAX_SCORE, DRAWER_MIN_SCORE, GUESSER_MAX_SCORE, GUESSER_MIN_SCORE, GUESSER_PLATEAU_MS, } from './constants.js';
function clamp01(value) {
    return value < 0 ? 0 : value > 1 ? 1 : value;
}
function checkedElapsed(elapsedMs) {
    if (!Number.isFinite(elapsedMs)) {
        throw new RangeError(`elapsedMs doit etre fini, recu ${String(elapsedMs)}`);
    }
    return elapsedMs < 0 ? 0 : elapsedMs;
}
function checkedDuration(guessTimeMs) {
    const value = guessTimeMs ?? DEFAULT_GUESS_TIME_MS;
    if (!Number.isFinite(value) || value <= 0) {
        throw new RangeError(`guessTimeMs doit etre fini et positif, recu ${String(guessTimeMs)}`);
    }
    return value;
}
/**
 * Devineur : plateau a GUESSER_MAX_SCORE pendant les 3 premieres secondes, puis
 * decroissance lineaire jusqu'a GUESSER_MIN_SCORE a la fin de la phase. Rate ou
 * timeout = 0.
 */
export function scoreGuesser(outcome) {
    if (!outcome.found)
        return 0;
    const duration = checkedDuration(outcome.guessTimeMs);
    const elapsed = checkedElapsed(outcome.elapsedMs);
    if (elapsed <= GUESSER_PLATEAU_MS)
        return GUESSER_MAX_SCORE;
    // Si la phase etait plus courte que le plateau, tout clic est "instantane".
    const span = duration - GUESSER_PLATEAU_MS;
    if (span <= 0)
        return GUESSER_MAX_SCORE;
    const progress = clamp01((elapsed - GUESSER_PLATEAU_MS) / span);
    return Math.round(GUESSER_MAX_SCORE + progress * (GUESSER_MIN_SCORE - GUESSER_MAX_SCORE));
}
/**
 * Dessinateur : DRAWER_MIN_SCORE si sa retouche est trouvee instantanement,
 * croissance lineaire jusqu'a DRAWER_MAX_SCORE a la fin de la phase. Jamais
 * trouvee = DRAWER_MAX_SCORE.
 */
export function scoreDrawer(outcome) {
    if (!outcome.found)
        return DRAWER_MAX_SCORE;
    const duration = checkedDuration(outcome.guessTimeMs);
    const elapsed = checkedElapsed(outcome.elapsedMs);
    const progress = clamp01(elapsed / duration);
    return Math.round(DRAWER_MIN_SCORE + progress * (DRAWER_MAX_SCORE - DRAWER_MIN_SCORE));
}
//# sourceMappingURL=scoring.js.map